var map = {
	"./arbitrum.svg": 615,
	"./aurora.svg": 616,
	"./avax.svg": 617,
	"./bsc.svg": 618,
	"./celo.svg": 619,
	"./cronos.svg": 620,
	"./emerald.svg": 621,
	"./ethereum.svg": 622,
	"./fantom.svg": 623,
	"./fuse.svg": 624,
	"./harmony.svg": 625,
	"./heco.svg": 626,
	"./kava.svg": 627,
	"./metis.svg": 628,
	"./moonbeam.svg": 629,
	"./moonriver.svg": 630,
	"./optimism.svg": 631,
	"./polygon.svg": 632
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 312;